import {gql} from '@apollo/client';

export const GET_ORDER_PRICE = gql`
    query orderPrice($input: OrderPreviewInput!){
        orderPrice(input: $input){
            totalPrice
            shippingPrice
            shippingDetail{
                from
                to
                overseas
                postServiceCode
                length
                width
                height
                weight
                postServiceCode
            }
        }
    }
`

export const GET_ORDER_PRICE_V2 = gql`
    query orderPriceV2($input: OrderCreateInputV2!){
        orderPriceV2(input: $input){
            grossTotal
            totalShippingPrice
            shippingDetail{
                to
                overseas
                postServiceCode
                postServiceCode
                deliveryLocation
                deliveryAddress
            }
        }
    }
`